// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RxfK","clinicsSelect":"styles_clinicsSelect__2UwMV"};